export const booleanPresenter = (value?: boolean): string => {
  if (value === undefined) {
    return '';
  }
  return value ? 'True' : 'False';
};
